import { BOOKING_STATUS } from 'constants/Booking'

import { COLORS, GENERAL_BOOKING_WAITING_STATUS } from '../constants'

export type CardTheme = {
  color: string
  bgColor: string
  btnBg: string
}

const CARD_THEMES: Record<number, CardTheme> = {
  [BOOKING_STATUS.Unassigned]: {
    color: COLORS.blue,
    bgColor: COLORS.white,
    btnBg: COLORS.red,
  },
  [BOOKING_STATUS.Recept]: {
    color: COLORS.white,
    bgColor: COLORS.red,
    btnBg: COLORS.green,
  },
  [BOOKING_STATUS.Booking]: {
    color: COLORS.blue,
    bgColor: COLORS.white,
    btnBg: COLORS.red,
  },
  [BOOKING_STATUS.Confirmed]: {
    color: COLORS.white,
    bgColor: COLORS.blue,
    btnBg: COLORS.red,
  },
  [BOOKING_STATUS.Delay_Expected]: {
    color: COLORS.orange,
    bgColor: COLORS.white,
    btnBg: COLORS.green,
  },
  [BOOKING_STATUS.Delay]: {
    color: COLORS.white,
    bgColor: COLORS.orange,
    btnBg: COLORS.red,
  },
  [BOOKING_STATUS.Arrival]: {
    color: COLORS.white,
    bgColor: COLORS.red,
    btnBg: COLORS.green,
  },
  [BOOKING_STATUS.Calling]: {
    color: COLORS.white,
    bgColor: COLORS.green,
    btnBg: COLORS.white,
  },
  [BOOKING_STATUS.Working]: {
    color: COLORS.green,
    bgColor: COLORS.white,
    btnBg: COLORS.red,
  },
  [BOOKING_STATUS.Finish]: {
    color: COLORS.white,
    bgColor: COLORS.gray,
    btnBg: COLORS.gray,
  },
}

const DEFAULT_THEME: CardTheme = {
  color: COLORS.darkGray,
  bgColor: COLORS.white,
  btnBg: COLORS.lightGray,
}

export const getCardTheme = (status: number): CardTheme => CARD_THEMES[status] || DEFAULT_THEME

/**
 * 未割り当てエリア用のカードテーマ
 * 通常予約と総合予約で配色が異なる
 */
export const getUnassignedCardTheme = (
  status: number,
  generalBookingId: number | null | undefined,
  generalBookingWaitingStatus: number | null | undefined
): CardTheme => {
  const isGeneralBooking = generalBookingId != null

  if (!isGeneralBooking) {
    // 通常予約: 既存テーマをそのまま使用
    return CARD_THEMES[status] || DEFAULT_THEME
  }

  // 総合予約
  if (status === BOOKING_STATUS.Unassigned) {
    return { color: COLORS.lightBlue, bgColor: COLORS.white, btnBg: COLORS.red }
  }

  // 受付済 (Arrival) の waiting_status による色分け
  if (
    generalBookingWaitingStatus == null ||
    generalBookingWaitingStatus === GENERAL_BOOKING_WAITING_STATUS.NEXT
  ) {
    // 先頭の受付済: 通常の受付済と同じ (赤背景)
    return { color: COLORS.white, bgColor: COLORS.red, btnBg: COLORS.green }
  }
  if (generalBookingWaitingStatus === GENERAL_BOOKING_WAITING_STATUS.SECOND) {
    // 2番目の受付済: ピンク背景
    return { color: COLORS.white, bgColor: COLORS.pink, btnBg: COLORS.pink }
  }
  // 3番目以降の受付済: 白背景/ピンク線
  return { color: COLORS.pink, bgColor: COLORS.white, btnBg: COLORS.pink }
}
